document.addEventListener('DOMContentLoaded', () => {
  function initHoverVideos() {
    document.querySelectorAll('.card-gallery').forEach((card) => {
      const deferredMedia = card.querySelector('deferred-media');
      if (!deferredMedia) return;

      const template = deferredMedia.querySelector('template');
      if (!template) return;

      card.addEventListener('mouseenter', () => {
        // Ativa o deferred-media se ainda não foi ativado
        if (!deferredMedia.hasAttribute('loaded')) {
          const content = template.content.cloneNode(true);
          deferredMedia.appendChild(content);
          deferredMedia.setAttribute('loaded', '');
        }

        const video = deferredMedia.querySelector('video');
        if (video) {
          video.muted = true;
          video.play();
        }
      });

      card.addEventListener('mouseleave', () => {
        const video = deferredMedia.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    });
  }

  initHoverVideos();
});
